const sortAlphabetical = (attributes) => attributes.sort(function(a, b) {
    const firstAttribute = a.name
    const secondAttribute = b.name
    
    return secondAttribute > firstAttribute ? -1 : secondAttribute < firstAttribute ? 1 : 0
})

export default sortAlphabetical